import CartoLink from '../../carto/carto_link';


function NetworkMap({ data, ec: {id}, type }) {
  const [focus_entities, focus_contacts] =
    type === "contact" ? [[], [id]] : [[id], []];

  let map_settings = data.map_settings_contact_entity_network || {};

  // enforce layout w/ mode: static when map is in a profile view (centered around an entity/or person)
  map_settings.layout = {...(map_settings.layout || {}), mode: "dynamic"};

  return <CartoLink
    links={data.links} contacts={data.contacts} entities={data.entities}
    trending={data.trending} affiliations={data.affiliations}
    map_settings={map_settings}
    focus_entities={focus_entities}
    focus_contacts={focus_contacts}
    />
}


export default NetworkMap;
